import { render, staticRenderFns } from "./interest-calculation-detail.vue?vue&type=template&id=6badf55e&scoped=true"
import script from "./interest-calculation-detail.vue?vue&type=script&lang=js"
export * from "./interest-calculation-detail.vue?vue&type=script&lang=js"
import style0 from "./interest-calculation-detail.vue?vue&type=style&index=0&id=6badf55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6badf55e",
  null
  
)

export default component.exports